import { render, staticRenderFns } from "./ThePrivacyPolicy.vue?vue&type=template&id=29a6969e&"
import script from "./ThePrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./ThePrivacyPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports